import React, {useState} from 'react'
import { 
    Layout,
    Col, 
    Row,
    // Button,
    // Dropdown, 
    // Space,
    // Modal,
    Select,
    Form,
    Input,
    // Tabs,
    // DatePicker
} from 'antd';
// import { useNavigate } from 'react-router-dom';
// import { ExclamationCircleFilled } from '@ant-design/icons';
// import { MoreVert  } from '@mui/icons-material';
import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
// import { DatePicker } from 'antd';
// const { RangePicker } = DatePicker;
// const { TabPane } = Tabs;
const { Item } = Form;
const { Search } = Input;
const { Option } = Select;
// const { confirm } = Modal;

const ExhibitorPaymentReport = () => {
    const [filterConfig, setFilterConfig] = useState({
        payment_id: "",
        type: "tenant",
        status: "open",
    })
    
    const data = [
        {
          key: '1',
          tenant: 'John Brown',
          payment_no: '1',
          payment_date: 'Jan 2 2024',
          amount: '12 000',
          remark: 'hi',
        },
        {
          key: '2',
          tenant: 'Jim Green',
          payment_no: '2',
          payment_date: 'Jan 9 2024',
          amount: '15 000',
          remark: 'hello',
        },
        {
          key: '3',
          tenant: 'Joe Black',
          payment_no: '3',
          payment_date: 'Jan 6 2024',
          amount: '23 000',
          remark: 'hi',
        },
        {
          key: '4',
          tenant: 'Jim Red',
          payment_no: '4',
          payment_date: 'Jan 1 2024',
          amount: '51 000',
          remark: 'hello',
        },
    ];
  
    const onSearch = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            search: e.target.value || ''
          }
        ));
    };   
  
    return (
        <Layout className='page'>
            <Navbar navKey={'exhibitors_receivable_report'}/>
            <Layout className='content-container'>
                <Row>
                    <Col span={24} className='header-container p-4'>
                        EXHIBITOR RECEIVABLE REPORT
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Row>
                            <Col span={12} className='p-4'>
                                <Item
                                    // label="Supplier Tradename"
                                    name="supplier_tradename"
                                    rules={[{ required: true, message: 'Please select your Tradename' }]} // Adjusted message
                                >
                                    <Select placeholder="Branch">
                                        <Option value="property1">SLI - Subscriber Line Installer</Option>
                                        <Option value="property2">Barks and Bubbles Pet Grooming and Care</Option>
                                        <Option value="property3">Cake Sarang Cake Shop</Option>
                                        {/* Add more options as needed */}
                                    </Select>
                                </Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12} align='end' className='p-4'>
                        <Search placeholder="input search text" size='medium' allowClear onSearch={onSearch} style={{ width: 250 }} />
                    </Col>
                </Row>
                <Row className='page-content'>
                    <Col span={24}>
                        <AntDTable
                            tableHeaders={[
                            "Exhibitor Name",
                            "Billing Number",
                            "Due Date",
                            "Balance",
                            ]}
                            headerSelector={[
                            "payment_no",
                            "tenant",
                            "payment_date",
                            "amount",
                            ]}
                            tableData={data}
                            // ActionBtn={(row) => ActionBtn(row)}
                            withAction={false}
                            // loading={showLoader}
                            // isClickable={true}
                            // rowClickPath={"/patients/profile"}
                            tablePages={10}
                            // handleTableChange={handleTableChange}
                            // filterConfig={filterConfig}
                            // totalSize={totalSize}
                            isSearch={true}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default ExhibitorPaymentReport

